import * as React from "react";
import Typography from "@material-ui/core/Typography";
import InputLabel from "@material-ui/core/InputLabel";
import { defaultTo, findLastIndex, path } from "ramda";
import { DeleteItemButton } from "./DeleteItemButton";
import { StyledHR } from "./StyledHR";
import { BasicTextField } from "./BasicTextField";
import { EJIItemFormValue, EJIServiceFormValue } from "../JobDetailsForm";
import { Box, Checkbox } from "@material-ui/core";

export const PartItemSection: React.FC<{
  editedService: EJIServiceFormValue;
  setEditedServiceAndRecalculatePrice: any;
  item: EJIItemFormValue;
  itemIdx: number;
  filteredParts: EJIItemFormValue[];
  useMultiplePartOrders?: boolean;
}> = ({
  editedService,
  setEditedServiceAndRecalculatePrice,
  item,
  itemIdx,
  filteredParts,
  useMultiplePartOrders,
}) => {
  return (
    <>
      <div className={"flex flex-row justify-between"}>
        <div className="text-lg font-bold">
          Part {findLastIndex((targetItem) => targetItem === item, filteredParts) + 1}
        </div>
        <DeleteItemButton
          editedService={editedService}
          setEditedServiceAndRecalculatePrice={setEditedServiceAndRecalculatePrice}
          itemToDelete={item}
        ></DeleteItemButton>
      </div>
      {editedService?.items[itemIdx]?.type !== null && (
        <div>
          <InputLabel shrink className="mb-1">
            Part Type
          </InputLabel>
          <Typography>{editedService?.items[itemIdx]?.type}</Typography>
        </div>
      )}
      <div className="grid grid-cols-2 gap-4">
        <BasicTextField
          value={
            useMultiplePartOrders
              ? editedService.items?.[itemIdx].expectedVendorUnitCost
              : editedService.items?.[itemIdx].vendorUnitCost
          }
          label={"Unit Cost"}
          inputMode="decimal"
          inputType="currency"
          onChange={(e) => {
            const tempItems = [...editedService.items];
            if (useMultiplePartOrders) {
              tempItems[itemIdx].expectedVendorUnitCost = e.target.value;
            } else {
              tempItems[itemIdx].vendorUnitCost = e.target.value;
            }
            setEditedServiceAndRecalculatePrice({
              ...editedService,
              items: [...tempItems],
            });
          }}
        />
        <BasicTextField
          value={editedService?.items[itemIdx]?.units}
          label={"Quantity"}
          inputMode="numeric"
          inputType="quantity"
          onChange={(e) => {
            const tempItems = [...editedService.items];
            tempItems[itemIdx].units = defaultTo(0)(Number(e.target.value));
            setEditedServiceAndRecalculatePrice({
              ...editedService,
              items: [...tempItems],
            });
          }}
        />
      </div>
      {editedService?.items[itemIdx]?.notes !== null && editedService?.items[itemIdx]?.notes?.length > 0 && (
        <div>
          <InputLabel shrink className="mb-1">
            Private Notes
          </InputLabel>
          <Typography>{editedService?.items[itemIdx]?.notes}</Typography>
        </div>
      )}
      {!!editedService?.id && (
        <div className={"flex flex-row items-center"}>
          <Checkbox
            checked={!editedService?.items[itemIdx]?.overriddenCustomerPrice}
            color="primary"
            inputProps={{ "aria-label": "secondary checkbox" }}
            onChange={(event) => {
              const value = path<boolean>(["target", "checked"], event);
              const tempItems = [...editedService.items];
              tempItems[itemIdx].overriddenCustomerPrice = !value;
              setEditedServiceAndRecalculatePrice({
                ...editedService,
                items: [...tempItems],
              });
            }}
          />
          <Typography>
            <Box>Update Customer Price</Box>
          </Typography>
        </div>
      )}
      <StyledHR />
    </>
  );
};
